import { MatDialogConfig } from "@angular/material/dialog";

export const BOOKING_DIALOG_CONFIG: MatDialogConfig = {
  width: "96vw",
  maxWidth: "1500px",
  height: "calc(100dvh - 32px)",
  maxHeight: "calc(100dvh - 32px)",
  panelClass: "booking-dialog-panel",
};
